import {
  EditorConfig,
  LexicalNode,
  NodeKey,
  ParagraphNode,
  SerializedParagraphNode,
  Spread,
} from 'lexical';
import { $isLocalizableTextNode } from './LocalizableTextNode';

export type SerializedProtectedParagraphNode = Spread<
  {
    type: 'protected-paragraph';
    version: 1;
  },
  SerializedParagraphNode
>;

export class ProtectedParagraphNode extends ParagraphNode {
  constructor(key?: NodeKey) {
    super(key);
  }

  static getType(): string {
    return 'protected-paragraph';
  }

  static clone(node: ProtectedParagraphNode): ProtectedParagraphNode {
    return new ProtectedParagraphNode(node.__key);
  }

  exportJSON(): SerializedProtectedParagraphNode {
    const serialized = super.exportJSON();
    return {
      ...serialized,
      type: 'protected-paragraph',
      version: 1,
    };
  }

  static importJSON(
    serializedNode: SerializedParagraphNode,
  ): ProtectedParagraphNode {
    const node = new ProtectedParagraphNode();
    node.setFormat(serializedNode.format);
    node.setIndent(serializedNode.indent);
    node.setDirection(serializedNode.direction);
    return node;
  }

  remove(preserveEmptyParent: boolean = false): void {
    const parent = this.getParent();

    if (parent?.getType() === 'root') {
      super.remove(preserveEmptyParent);
      return;
    }

    const children = this.getChildren();
    for (const child of children) {
      if ($isLocalizableTextNode(child)) {
        if (
          child.__originalLanguage &&
          child.__originalLanguage === child.__pageDesignerLanguage
        ) {
          return;
        }
      }
    }

    super.remove(preserveEmptyParent);
  }

  createDOM(config: EditorConfig): HTMLElement {
    return super.createDOM(config);
  }

  updateDOM(
    prevNode: ParagraphNode,
    dom: HTMLElement,
    config: EditorConfig,
  ): boolean {
    return super.updateDOM(prevNode, dom, config);
  }
}

export function $createProtectedParagraphNode(): ProtectedParagraphNode {
  return new ProtectedParagraphNode();
}

export function $isProtectedParagraphNode(
  node: LexicalNode | null | undefined,
): node is ProtectedParagraphNode {
  return node instanceof ProtectedParagraphNode;
}
